module.exports = __webpack_public_path__ + "img/213.21b80c38.jpg";